export default function BrandIntro() {
  return (
    <section className="py-14 md:py-20">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            关于海角社区
          </h1>
          <p className="text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            连接你我的温暖交流平台
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-10 items-center">
          <div className="flex-1">
            <h2 className="text-xl font-heading font-bold text-foreground-950 mb-4">
              我们的故事
            </h2>
            <p className="text-foreground-700 leading-relaxed mb-4">
              海角社区创立于2023年，源于创始团队一个简单而真诚的想法：在这个信息爆炸的时代，人们需要一个可以慢下来、真诚交流的地方。不是喧嚣的社交媒体，不是冰冷的资讯平台，而是一个像朋友家客厅一样温暖的空间。
            </p>
            <p className="text-foreground-700 leading-relaxed mb-4">
              之所以取名"海角"，是希望无论你身处世界的哪个角落，都能在这里找到归属感。天涯若比邻，海角即家园。我们相信，每一个普通人都有值得被倾听的故事，每一个真诚的分享都能带来温暖和力量。
            </p>
            <p className="text-foreground-700 leading-relaxed">
              三年来，从最初的几十个用户，到如今的上万社区成员，海角社区始终坚持初心：做一个开放、包容、有温度的交流平台。这里没有大V和小透明的区别，每一条分享都值得被认真对待。
            </p>
          </div>
          <div className="flex-shrink-0 w-full lg:w-80">
            <div className="aspect-square rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20abstract%20artistic%20illustration%20of%20diverse%20people%20connecting%20through%20soft%20flowing%20lines%20and%20organic%20shapes%2C%20warm%20terracotta%20amber%20and%20cream%20tones%2C%20community%20and%20connection%20concept%2C%20minimalist%20modern%20art%20style%2C%20no%20text&width=800&height=800&seq=about-brand-2026&orientation=squarish"
                alt="海角社区品牌形象"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>

        {/* Mission */}
        <div className="mt-16 grid grid-cols-1 sm:grid-cols-3 gap-6">
          {[
            {
              icon: 'ri-eye-line',
              title: '我们的愿景',
              desc: '成为中国最有温度的在线交流社区，让每个人都能被听见、被理解、被温暖。',
            },
            {
              icon: 'ri-flag-line',
              title: '我们的使命',
              desc: '创造一个开放包容的交流空间，连接每一个渴望真诚交流的灵魂。',
            },
            {
              icon: 'ri-heart-pulse-line',
              title: '我们的价值观',
              desc: '真诚、包容、温暖、成长。尊重每一种声音，珍惜每一份连接。',
            },
          ].map((item) => (
            <div key={item.title} className="bg-background-100 rounded-xl p-6 text-center">
              <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-accent-100 flex items-center justify-center">
                <i className={`${item.icon} text-xl text-accent-500 w-6 h-6 flex items-center justify-center`}></i>
              </div>
              <h3 className="font-heading font-bold text-foreground-950 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}